import axios from 'axios'

export default {
    async getForWorkShifts() {
        try{            
            const response = await axios.get(`Colors/workshifts`)            
            return response
        }catch (error){
            console.log('getForWorkShifts api error')
            throw error
        }
    },
}